import * as React from 'react';

import TimelineVideo from '../../../../timeline/TimelineVideo/TimelineVideo';

const VideoPreview = require('../../../../../assets/img/timeline/modal/1978-Establishment.jpg');

interface IEstablishmentContentProps {

}

const EstablishmentContent = () => {
    return (
        <>
            <TimelineVideo videoId="s88jP5OdQJc" imagePreview={VideoPreview} />
            <h4>
                Establishment of the Australian New Zealand Breast Cancer Trials Group (now Breast Cancer Trials)
            </h4>
            <p>
                Establishment of the Australian New Zealand Breast Cancer Trials Group (now Breast Cancer Trials), in the Department of Surgery, University of Melbourne at the Royal Melbourne Hospital. The Group started with one Data Manager, one computer, one National Health and Medical Research Council (NHMRC) grant and 14 collaborating institutions. Professor John Forbes AM was the Group Coordinator.
            </p>
        </>
    );
}

export default EstablishmentContent;